export default "__VITE_ASSET__37a775c8__"